import {createIcon} from '@chakra-ui/react'

export const OpenInNewIcon = createIcon({
  displayName: 'OpenInNewIcon',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M3.75 2.75H8.5V3.25H3.25V14.75H14.75V9.5H15.25V14.25C15.25 14.7989 14.7989 15.25 14.25 15.25H3.75C3.19527 15.25 2.75 14.8005 2.75 14.25V3.75C2.75 3.19951 3.19527 2.75 3.75 2.75ZM15.25 2.75V7H14.75V3.60059L6.87793 11.4727L6.52734 11.1221L14.3994 3.25H11V2.75H15.25Z"
      fill="black"
      stroke="white"
    />
  ),
})
